import BottomSheet from "../common/bottom-sheet";
import { useFirstVisitState } from "./hooks/use-first-visit-state";
import { useSourceValidation } from "./hooks/use-source-validation";
import { useSourceFocus } from "./hooks/use-source-focus";
import { useSourceSubmission } from "./hooks/use-source-submission";
import { useUrlManagement } from "./hooks/use-url-management";
import { SourceSelector } from "./components/source-selector";
import { SourceSubmitButton } from "./components/source-submit-button";

interface FirstVisitBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const FirstVisitBottomSheet = ({
  isOpen,
  onClose,
}: FirstVisitBottomSheetProps) => {
  // 상태 관리 훅
  const {
    selectedSource,
    selectedSubSource,
    selectedSubSubSource,
    subSourceTexts,
    otherSourceText,
    isSubmitting,
    setSelectedSource,
    setSelectedSubSource,
    setSelectedSubSubSource,
    setOtherSourceText,
    setIsSubmitting,
    updateSubSourceText,
    clearSubSourceTexts,
  } = useFirstVisitState();

  // 검증 훅
  const { allTextInputs, isValid, buttonText } = useSourceValidation({
    selectedSource,
    selectedSubSource,
    subSourceTexts,
    otherSourceText,
  });

  // 포커스 훅
  const { textInputRef } = useSourceFocus({
    selectedSource,
    selectedSubSource,
    allTextInputs,
  });

  // URL 관리 훅
  const { removeFirstVisitParam } = useUrlManagement();

  // 제출 훅
  const { submitSource } = useSourceSubmission({
    selectedSource,
    selectedSubSource,
    selectedSubSubSource,
    subSourceTexts,
    otherSourceText,
    onSuccess: () => {
      onClose();
      removeFirstVisitParam();
    },
  });

  const handleSourceSkip = () => {
    onClose();
    removeFirstVisitParam();
  };

  const handleSourceSubmit = async () => {
    if (!isValid) return;
    setIsSubmitting(true);
    await submitSource();
    setIsSubmitting(false);
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      mainText="자그마한 선물이 준비되어있어요 🎁"
      onClose={handleSourceSkip}
      onButtonClick={handleSourceSubmit}
      buttonText={isSubmitting ? "저장 중..." : buttonText}
      disableDrag={true}
    >
      <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
        <p className="text-gray-700 text-center text-md">
          어떻게 마히를 알게 되셨나요?
        </p>
        <SourceSelector
          selectedSource={selectedSource}
          selectedSubSource={selectedSubSource}
          selectedSubSubSource={selectedSubSubSource}
          subSourceTexts={subSourceTexts}
          otherSourceText={otherSourceText}
          onSourceSelect={setSelectedSource}
          onSubSourceSelect={setSelectedSubSource}
          onSubSubSourceSelect={setSelectedSubSubSource}
          onSubSourceTextUpdate={updateSubSourceText}
          onOtherSourceTextChange={setOtherSourceText}
          onSubSourceClear={() => {
            setSelectedSubSource("");
            setSelectedSubSubSource("");
            clearSubSourceTexts();
          }}
          onOtherSourceClear={() => setOtherSourceText("")}
          textInputRef={textInputRef}
        />

        <SourceSubmitButton
          isSubmitting={isSubmitting}
          buttonText={buttonText}
          onSkip={handleSourceSkip}
        />
      </div>
    </BottomSheet>
  );
};

export default FirstVisitBottomSheet;
